import { post2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { useMutation } from "@tanstack/react-query";

const useOrderTrackerIconSignature = () => {
  const branchId = useBranchId();
  const mutation = useMutation({
    mutationFn: () =>
      post2(
        `/internal/secure/pos/v1/orderTracker/settings/upload/icons/${branchId}`,
        {}
      ),
  });
  return mutation;
};

export default useOrderTrackerIconSignature;
